import { router, usePage } from "@inertiajs/react";
import { Select, ThemeIcon, Tooltip } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { getYearString } from "../../helpers/stringHelper";
import { useRole, useYearContexts } from "../../hooks/useProps";
import { useYearContext } from "../../hooks/useYearContext";
import { Role } from "../../models/enums/role";

const yearContextAffectedPages = [
  "observation/ObservationCreate",
  "users/apprentice/Apprentices",
  "report/Reports",
  "document/general/Documents",
];

export function YearContextSelect() {
  const { url, component } = usePage();
  const urlParts = url.split("/");
  const role = useRole();

  // all years
  const yearContexts = useYearContexts();

  // current selected Year
  const { year_starts } = useYearContext();
  const currentYearContext = yearContexts?.find((y) => y.starts_at === year_starts);

  // display and disable checks
  const displayYearContext = yearContexts && (role === Role.ADMIN || Role.APPRENTICE_SUPERVISOR);
  const disableYearContext = !yearContextAffectedPages.includes(component);

  const onChange = (value: string | null) => {
    const selectedYearContext = yearContexts?.find((y) => y.starts_at.toString() === value);
    if (value) {
      const relevantUrlParts = urlParts.slice(3);
      router.visit(`/${selectedYearContext?.starts_at}/${selectedYearContext?.ends_at}/${relevantUrlParts.join("/")}`);
    }
  };

  return (
    <>
      {displayYearContext && !currentYearContext?.current && (
        <Tooltip label="Nicht das aktuelle Jahr">
          <ThemeIcon color="zli-orange" variant="white">
            <IconAlertTriangle />
          </ThemeIcon>
        </Tooltip>
      )}
      {displayYearContext && (
        <Tooltip disabled={!disableYearContext} label="Der Jahrgang kann nicht geändert werden oder hat keinen Einfluss auf die Seite">
          <Select
            placeholder="Jahrgang"
            value={year_starts.toString()}
            disabled={disableYearContext}
            data={yearContexts?.map((y) => ({
              value: y.starts_at.toString(),
              label: getYearString(y),
            }))}
            onChange={onChange}
          />
        </Tooltip>
      )}
    </>
  );
}
